module.exports = __webpack_public_path__ + "img/gypsophile.aa01fe37.jpg";